import * as actionTypes from './actionTypes';


export const confirmUserAudit = (spaceId) => ({
  type: actionTypes.CONFIRM_USER_AUDIT,
  spaceId,
});
export const confirmUserAuditSuccess = () => ({
  type: actionTypes.CONFIRM_USER_AUDIT_SUCCESS,
});
export const confirmUserAuditError = (error) => ({
  type: actionTypes.CONFIRM_USER_AUDIT_ERROR,
  error,
});

export const fetchAuditPendingRoleIdsForSpaceId = (spaceId) => ({
  type: actionTypes.FETCH_PENDING_ROLE_IDS,
  spaceId,
});
export const fetchAuditPendingRoleIdsForSpaceIdSuccess = (ids, spaceId) => ({
  type: actionTypes.FETCH_PENDING_ROLE_IDS_SUCCESS,
  ids,
  spaceId,
});
export const fetchAuditPendingRoleIdsForSpaceIdError = (error) => ({
  type: actionTypes.FETCH_PENDING_ROLE_IDS_SUCCESS,
  error,
});


export const confirmRoleAudit = (spaceId, role) => ({
  type: actionTypes.CONFIRM_ROLE_AUDIT,
  spaceId,
  role,
});
export const confirmRoleAuditSuccess = (spaceId, roleId) => ({
  type: actionTypes.CONFIRM_ROLE_AUDIT_SUCCESS,
  spaceId,
  roleId,
});
export const confirmRoleAuditError = (error) => ({
  type: actionTypes.CONFIRM_ROLE_AUDIT_ERROR,
  error,
});
